import CheckTviConnectPage from './CheckTviConnectPage'

export default CheckTviConnectPage
